import { asyncLocalStorage } from '../../src/components/common/commonFunction';

export const login = "/login";

let farmId = localStorage.getItem(process.env.REACT_APP_LOGIN_FARM_ID);
// let farmId = "63153f67df6a876d80a43df1";
// console.log("farmId: ", farmId);


export const identity = "/identity";
export const updateProfile = "/update-profile";
export const changePassword = "/change-password";

export const dashboardData = "/dashboard/data";

export const personCreate = "/person/store";
export const personRead = "/person/_ID_/read";
export const personUpdate = "/person/_ID_/update";
export const personDelete = "/person/_ID_/delete";
export const personList = "/persons";

export const treeCreate = "/tree/store";
export const treeRead = "/tree/_ID_/read";
export const treeUpdate = "/tree/_ID_/update";
export const treeDelete = "/tree/_ID_/delete";
export const treeList = `/farm/${farmId}/trees`;

export const zoneCreate = "/zone/store";
export const zoneRead = "/zone/_ID_/read";
export const zoneUpdate = "/zone/_ID_/update";
export const zoneDelete = "/zone/_ID_/delete";
export const zoneList = `/${farmId}/zones`;

export const sectorCreate = "/sector/store";
export const sectorRead = "/sector/_ID_/read";
export const sectorUpdate = "/sector/_ID_/update";
export const sectorDelete = "/sector/_ID_/delete";
export const sectorList = `/${farmId}/sectors`;

export const illnessCreate = "/illness/store";
export const illnessRead = "/illness/_ID_/read";
export const illnessUpdate = "/illness/_ID_/update";
export const illnessDelete = "/illness/_ID_/delete";
// export const illnessList = "/illnesses";
export const illnessList = `/farm/${farmId}/illnesses`;


export const rawMaterialCreate = "/raw-material/store";
export const rawMaterialRead = "/raw-material/_ID_/read";
export const rawMaterialUpdate = "/raw-material/_ID_/update";
export const rawMaterialDelete = "/raw-material/_ID_/delete";
export const rawMaterialList = `/farm/${farmId}/raw-materials`;

export const agriculturalPracticeCreate = "/agricultural-practice/store";
export const agriculturalPracticeRead = "/agricultural-practice/_ID_/read";
export const agriculturalPracticeUpdate = "/agricultural-practice/_ID_/update";
export const agriculturalPracticeDelete = "/agricultural-practice/_ID_/delete";
export const agriculturalPracticeList = `/farm/${farmId}/agricultural-practices`;

export const workPlanCreate = "/work-plan/store";
export const workPlanRead = "/work-plan/_ID_/read";
export const workPlanUpdate = "/work-plan/_ID_/update";
export const workPlanDelete = "/work-plan/_ID_/delete";
export const workPlanList = `/farm/${farmId}/work-plans`;

export const purchaseCreate = "/purchase/store";
export const purchaseRead = "/purchase/_ID_/read";
export const purchaseUpdate = "/purchase/_ID_/update";
export const purchaseDelete = "/purchase/_ID_/delete";
export const purchaseList = `/${farmId}/purchases`;

export const expertMonitorCreate = "/tree-illness/store";
export const expertMonitorRead = "/tree-illness/_ID_/read";
export const expertMonitorUpdate = "/tree-illness/_ID_/update";
export const expertMonitorDelete = "/tree-illness/_ID_/delete";
export const expertMonitorList = `/${farmId}/tree-illnesses`;
